const inFrame = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export default inFrame;
